import React from 'react';
import { useMedia } from 'use-media';
import classNames from 'classnames';
import { CustomVideoPlayer } from '@shared/ui/custom-video-player';
import s from './onboarding-video.module.scss';

export const OnboardingVideo = ({ desktopUrl, mobileUrl, className }) => {
	const isMobile = useMedia({ maxWidth: '768px' });
	const url = isMobile ? mobileUrl : desktopUrl;

	return (
		<div className={classNames(s.wrapper, isMobile ? s.mobile : s.desktop, className)}>
			<CustomVideoPlayer
				className={s.videoPlayer}
				wrapperClassName={s.playerWrapper}
				src={url}
				autoPlay
				muted
				loop
				playsInline
				controls={false}
				allowFullscreen={false}
				allowPiP={false}
				allowSpeed={false}
				showBigPlayButton={false}
			/>
		</div>
	);
};
